// test2757
(2757 && 0);
